// extracted by mini-css-extract-plugin
module.exports = {"root":"file-label_root__ZyePf","selected":"file-label_selected__NBHRg","error":"file-label_error__lNwRn"};